import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,1807.05882 C492.875294,1807.05882 112.941176,1427.12471 112.941176,960 C112.941176,492.875294 492.875294,112.941176 960,112.941176 C1427.12471,112.941176 1807.05882,492.875294 1807.05882,960 C1807.05882,1427.12471 1427.12471,1807.05882 960,1807.05882 M960,0 C430.644706,0 0,430.644706 0,960 C0,1489.35529 430.644706,1920 960,1920 C1489.35529,1920 1920,1489.35529 1920,960 C1920,430.644706 1489.35529,0 960,0 M854.343529,1157.97459 L583.058824,886.689882 L503.209412,966.539294 L854.343529,1317.67341 L1454.4,717.616941 L1374.55059,637.767529 L854.343529,1157.97459 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconPublishLine = /*#__PURE__*/function (_Component) {
  _inherits(IconPublishLine, _Component);

  var _super = _createSuper(IconPublishLine);

  function IconPublishLine() {
    _classCallCheck(this, IconPublishLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconPublishLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconPublish",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconPublishLine.displayName = "IconPublishLine";
  return IconPublishLine;
}(Component);

IconPublishLine.glyphName = 'publish';
IconPublishLine.variant = 'Line';
IconPublishLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconPublishLine;
export { IconPublishLine };